import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    outTimeWorkList: () => {
        return HTTP.get('/work_time/workTimeOut', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    outWork: (id,data) => {
        return HTTP.post('/work_time/workTimeOutUpdate/'+id, data,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    workTimeOutUpdate: (data) => {
        return HTTP.post('/work_time/workTimeOutUpdatesum', data,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}